import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-origem-monitor',
  templateUrl: './origem-monitor.component.html',
  styleUrls: ['./origem-monitor.component.css']
})
export class OrigemMonitorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
